import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appointmentAsMemberQueryKeys } from "./appointmentAsMemberQueryKeys";

export const useMutationAppointmentUpdateAsMember = ({
  api,
}: {
  api: ApiType;
}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      params: Parameters<ApiType["customerAppointmentApi"]["update"]>[0],
    ) => (await api.customerAppointmentApi.update(params)).data,
    onSuccess: async () =>
      await queryClient.invalidateQueries({
        queryKey: appointmentAsMemberQueryKeys.all(),
      }),
  });
};
